module.exports = __webpack_public_path__ + "static/media/sk9.e7a90dbc.png";